import { graphql } from "../../generated";

export const clientsQuery = graphql(/* GraphQL */ `
    query Clients {
        clients {
            items {
                ...clientItemFields
                role
            }
        }
    }
`);

export const clientQuery = graphql(/* GraphQL */ `
    query Client($clientId: String!) {
        client(clientId: $clientId) {
            ...clientDetailFields
        }
    }
`);

export const clientUsersQuery = graphql(/* GraphQL */ `
    query ClientUsers($clientId: String!, $nextToken: String) {
        client(clientId: $clientId) {
            id
            users(nextToken: $nextToken) {
                nextToken
                items {
                    ...clientUserFields
                }
            }
        }
    }
`);

export const clientCreditsQuery = graphql(/* GraphQL */ `
    query ClientCredits($clientId: String!) {
        client(clientId: $clientId) {
            id
            credits {
                availableBalanceCredits
            }
        }
    }
`);

export const clientInvoicesQuery = graphql(/* GraphQL */ `
    query ClientInvoices($clientId: String!, $nextToken: String) {
        client(clientId: $clientId) {
            id
            invoices(nextToken: $nextToken) {
                nextToken
                items {
                    ...invoiceFields
                }
            }
            users {
                nextToken
            }
        }
    }
`);

export const clientTenantsQuery = graphql(/* GraphQL */ `
    query ClientTenants($clientId: String!, $nextToken: String) {
        client(clientId: $clientId) {
            id
            tenants(nextToken: $nextToken) {
                nextToken
                items {
                    ...tenantItemFields
                }
            }
        }
    }
`);

export const clientTenantQuery = graphql(/* GraphQL */ `
    query ClientTenant($clientId: String!, $tenantId: String) {
        client(clientId: $clientId) {
            id
            tenant(tenantId: $tenantId) {
                ...tenantDetailFields
            }
        }
    }
`);
